module.exports = __webpack_public_path__ + "21_cikm.jpg?f6aa27815147a8f72e208e9733c1f401";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/21_cikm.jpg
// module id = 176
// module chunks = 0